var i = Object.defineProperty;
var p = (s, t, e) => t in s ? i(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var r = (s, t, e) => p(s, typeof t != "symbol" ? t + "" : t, e);
import { HttpClient as u, httpClient as n } from "../../httpClient.js";
class c extends u {
  constructor() {
    super(...arguments);
    r(this, "endpoint", "/user-notes");
  }
  async getAllForObjective(e) {
    return n.get(`${this.endpoint}/${e}`);
  }
  async getAllForLesson(e) {
    return n.get(`${this.endpoint}/lesson/${e}`);
  }
  async getAllForCourse(e) {
    return n.get(`${this.endpoint}/course/${e}`);
  }
  async getCourseNotes(e) {
    return n.get(
      `${this.endpoint}/course/${e}`
    );
  }
  async create(e) {
    return n.post(this.endpoint, e);
  }
  async update(e, o) {
    return n.put(`${this.endpoint}/${e}`, o);
  }
  async remove(e) {
    return n.delete(`${this.endpoint}/${e}`);
  }
}
const l = new c();
export {
  l as default
};
